<script lang="ts" setup>
  import BaseHelp from "frontend/components/base/BaseHelp.vue";
</script>

<template>
  <div class="vue-route__not-found plain">
    <h2>Terminbuchung gesperrt</h2>
    <BaseHelp>
      <p>
        Die Terminbuchung wurde durch Ihre Praxis derzeit gesperrt. Dies
        ermöglicht das gefahrfreie Bearbeiten Ihrer Praxiseinstellungen und
        verhindert, dass Patienten während umfassenden Änderungen Termine
        (versehentlich) buchen können.
      </p>
    </BaseHelp>
    <p>In der Kopfzeile können Sie die Terminbuchung wieder freigeben.</p>
    <p>
      <strong>Achtung:</strong> Stellen Sie sicher, dass die Einstellungen
      bereits fertig bearbeitet wurden und nicht zum Beispiel an einem anderen
      Rechner in Ihrer Praxis gerade bearbeitet werden.
    </p>
  </div>
</template>
